import React from 'react';
import { StyleProp, StyleSheet, Text, View, ViewStyle } from 'react-native';
import Icon from 'react-native-vector-icons/FontAwesome';
import useFontSize from '../../shell/hooks/useFontSize';

interface InstaNavBarProps {
    style?: StyleProp<ViewStyle>,
    onCloseClick: () => void;
}

export const InstaNavBar: React.FC<InstaNavBarProps> = ({ style, onCloseClick }) => {

    const styles = StyleSheet.create({
        nav: {
            width: "100%",
            backgroundColor: "white",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            paddingLeft: "1%",
            paddingRight: "1%",
            height: "5%",
            alignItems: "center",
            borderBottomColor: "#e2e2e2b5",
            borderBottomWidth: 1,
        },
        font: {
            color:"black",
            fontSize: useFontSize(2.5)
        },
        x: {

            color:"black",
            fontSize: useFontSize(4)
        }

    });
    return (
        <View style={[styles.nav, style]}>
            <Text style={styles.font}>Insta</Text>
            {/* <Text style={styles.x}>X</Text>*/}
            <Icon name="times" style={styles.x} size={useFontSize(4)} onPress={() => onCloseClick()} />
        </View>
    );
};